import "./import-jquery";
import * as bootstrap from 'bootstrap';
import 'zeynepjs'
import "owl.carousel"

// window.onload = function() {
//   if (window.jQuery) {
//       // jQuery is loaded
//       alert("Yeah!");
//   } else {
//       // jQuery is not loaded
//       alert("Doesn't Work");
//   }
// }
$(window).on('load', function() {
  $(".se-pre-con").fadeOut("slow");
});



$(function() {
  // loop all zeynepjs menus for initialization
  $('.zeynep').each(function () {
    // init zeynepjs side menu
    $(this).zeynep({
      opened: function (el) {
        // log
        console.log(el.attr('data-menu-name') + ' side menu opened')
      },
      closed: function (el) {
        // log
        console.log(el.attr('data-menu-name') + ' side menu closed')
      }
    })
  })

  // handle zeynepjs overlay click
  $('.zeynep-overlay').on('click', function () {
    // close all zeynepjs menus
    $('.zeynep.opened').each(function () {
      $(this).data('zeynep').close()
    })
  });

  // open first zeynepjs side menu
  $('.btn-open.first').on('click', function () {
    $('.zeynep.first').data('zeynep').open();
  });

  // open second zeynepjs side menu
  $('.btn-open.second').on('click', function () {
    $('.zeynep.second').data('zeynep').open();
  });



  $('.hero-sldr').owlCarousel({
    loop: true,
    nav: true,
    dots: false,
    autoplay: true,
autoplayTimeout:1119800,
    items: 1,
    navText: [
        "<i class='ti-angle-left'></i>",
        "<i class='ti-angle-right'></i>"
    ],
});



/* ==================================================
            # Carousel Carousel
         ===============================================*/
         $('.cate-sol').owlCarousel({
          loop: true,
          nav: true,
          margin:30,
          dots: false,
          autoplay: true,
          autoplayTimeout:1119800,
          navText: [
              "<i class='fa fa-angle-left'></i>",
              "<i class='fa fa-angle-right'></i>"
          ],
          responsive: {
      0: {
                  items: 1
              },
              768: {
                  items: 2
              },
      992: {
                  items: 3
              },
          }
      });



      	/* ==================================================
            # Review Carousel
         ===============================================*/

         $('.rev-sldr').owlCarousel({
          loop: true,
          margin:30,
          nav: false,
          navText: [
              "<i class='icofont-long-arrow-left'></i>",
              "<i class='icofont-long-arrow-right'></i>"
          ],
          dots: true,
          autoplay: true,
          responsive: {
              0: {
                  items: 1
              },
              768: {
                  items: 2
              },
              992: {
                  items: 2
              }
          }
      });


      var Swipes = new Swiper('.swiper-container', {
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
        },
    });

});
